import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { Loader } from "react-loaders";
import Dropdown from './dashboard-select';
import { getRequest, batchRequest } from "../../api/ApiService";
import ArrowIcon from '../../containers/assets/arrow2.svg';
import StudentStatsViewEvaluation from "./student-stats-view-evaluation";

const EngagementModal = styled(Modal)`
  background: rgba(0, 0, 0, 0.5) !important;

  .modal-dialog {
    width: 1077px !important;

    .modal-content {
      padding: 0 !important;
      border-radius: 4px !important;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
      border: none !important;
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 64px 40px 27px !important;
  min-height: 250px;

  .loader {
    width: 100%;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 36px;
        margin-bottom: -48px;
        border-color: #2a4169;
      }
    }
  }

  ${p => p.evaluationVisible && `
    height: 737px;
  `}
`;

const FullWidth = styled.div`
  width: 100%;
`;

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
`;

const Title = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 28px;
  line-height: 36px;
  color: rgba(0, 27, 59, 0.94);
`;

const DropDownContainer = styled.div``;

const DropDownHeader = styled.div`
  display: block;
  width: 137px;
  height: 32px;
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.94);
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
  border-radius: 4px;
  text-align: center;
  line-height: 32px;
  padding: 0 25px 0 15px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 27, 59, 0.94);

  cursor: pointer;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DropDownListContainer = styled.div`
  position: absolute;
  z-index: 2;
  padding-top: 4px;
`;

const DropDownHeaderArrow = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 23px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const SubTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 27, 59, 0.15);
  flex-basis: 100%;
  padding-bottom: 7px;
`;

const SubTitle = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
`;

const BlockWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  flex-basis: 820px;
  margin-top: 20px;
`;

const GreyBlock = styled.div`
  width: 370px;
  background: rgba(0, 27, 59, 0.04);
  border-radius: 4px;
  padding: 20px;
  flex-basis: 370px;

  ${p => p.isMinHeight && `
    height: auto;
    min-height: 120px;
    padding-bottom: 20px;
  `}

  &:nth-child(odd) {
    width: 430px;
    flex-basis: 430px;
  }

  ${p => p.fullWidth && `
    flex-basis: 100% !important;
  `}
`;

const GreyBlockTitle = styled.span`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-bottom: 10px;
  display: inline-block;
  white-space: nowrap;
`;

const GreyBlockRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${p => p.justify && `
  justify-content: ${p.justify};
  `}
`;

const GreyBlockCell = styled.div`
  display: flex;
  align-items: center;
`;

const GreyBlockLabel = styled.span`
  display: inline-block;
  border: 1.5px solid #2A4169;
  color: #2A4169;
  padding: 1px 8px;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 23px;
  border-radius: 8px;
  margin-right: 10px;
  background: #fff;
`;

const GreyBlockValue = styled.span`
  display: inline-block;
  color: #001B3B;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
`;

const GreyBlockText = styled.span`
  font-family: 'Mukta Vaani', sans-serif;
  color: #001B3B;
  font-weight: 500;
  font-size: 16px;
  line-height: 36px;
`;

const getPercentage = value => (
  value > 0 ? `${(value * 100).toFixed(1)}%` : "---"
);

class StudentStatsPopup extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      students: null,
      selected: null,
      isFetching: false,
      setDropdownValueCallback: null,
      evaluationVisible: false
    };
  }

  fetchPaginationData = (url, dataField, pageSize, callback) => {
    this.setState({
      [dataField]: [],
    });

    getRequest(`${url}${url.indexOf('?') > 0 ? '&' : '?'}page_size=1`)
      .then(res => {
        const { count } = res.body;

        if (count > 0) {
          const pages = Math.ceil(count / pageSize);
          const requests = [];

          for (let i = 1; i <= pages; i++) {
            requests.push(`${url}${url.indexOf('?') > 0 ? '&' : '?'}page_size=${pageSize}&page=${i}`);
          }

          batchRequest(requests)
            .then(res => {
              try {
                const data = res.flatMap(payload => payload.body.results);
                this.setState({
                  [dataField]: data,
                }, () => {
                  if (callback) {
                    callback();
                  }
                });
              } catch (e) {
                console.log(e);
              }
            })
            .catch(err => { });
        } else if (callback) {
          callback();
        }
      })
      .catch(err => { });
  }

  async componentDidMount() {
    const { setLoadingState } = this.props;

    this.fetchPaginationData(
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/`,
      'students',
      100,
      () => {
        const { setDropdownValueCallback } = this.state;
        setLoadingState(false);

        const students = this.studentsList;
        if (setDropdownValueCallback && students && students.length > 0) {
          setDropdownValueCallback(students[0]);
        }
      }
    );
  }

  get studentsList() {
    const { students } = this.state;

    const result = students ? students
      .filter(student => ['CEO', 'PD', 'PM', 'OP', 'FI'].includes(student.role))
      .map(student => `${student.user.first_name} ${student.user.last_name}`) : [];
    result.sort((a, b) => a.localeCompare(b));

    return result;
  }

  onSelectStudent = async (value) => {
    const { students } = this.state;
    const {
      roundNumber,
      roundId,
      gameId,
      selectPlayer
    } = this.props;
    const student = students.find(i => `${i.user.first_name} ${i.user.last_name}` === value);

    const userId = student.user.id ? student.user.id : 0;
    selectPlayer(userId);

    this.setState({
      isFetching: true,
      selected: null,
    });

    if (student) {
      let teamName = null;
      try {
        const res = await getRequest(
          `${process.env.REACT_APP_API_URL}teams/`
        );
        const team = res.body.find(i => i.id === student.team);
        if (team) {
          teamName = team.name;
        }
      } catch (err) {
        console.log('Cannot get teams list', err);
      }

      let teamGradingsRaw = null;
      let gamesUpgradeRaw = null;
      let feedbackSubmissionScoresRaw = null;
      let engagementRaw = null;

      let res1 = null;
      let res2 = null;
      let res3 = null;
      let res4 = null;

      try {
        res1 = await getRequest(`${process.env.REACT_APP_API_URL}v2/games/teamgradings/?team=${student.team}&round=${roundId}`);
      } catch (err) {
        console.log('Cannot get student stats [res1]', err);
      }

      try {
        res2 = await getRequest(`${process.env.REACT_APP_API_URL}v2/games/usergrade/${roundId}/${userId}/`);
      } catch (err) {
        console.log('Cannot get games usergrade [res2]', err);
      }

      try {
        res3 = await getRequest(`${process.env.REACT_APP_API_URL}v2/forms/feedback-submission-scores/`);
      } catch (err) {
        console.log('Cannot get feedback submission scores [res3]', err);
      }

      try {
        res4 = await getRequest(`${process.env.REACT_APP_API_URL}v2/engagement/engagementuserscores/?user=${userId}&game=${gameId}&round_number=${roundNumber}`);
      } catch (err) {
        console.log('Cannot get engagementuserscores [res4]', err);
      }

      teamGradingsRaw = res1 && res1.statusCode === 200 ? res1.body : null;
      const teamScore = teamGradingsRaw && teamGradingsRaw.results && teamGradingsRaw.results.length > 0
        ? Number(teamGradingsRaw.results[0].weighted_value)
        : 0;

      gamesUpgradeRaw = res2 && res2.statusCode === 200 ? res2.body : null;
      const collaborationScore = gamesUpgradeRaw && gamesUpgradeRaw.peer_adjustment_grade
        ? Number(gamesUpgradeRaw.peer_adjustment_grade)
        : 0;

      feedbackSubmissionScoresRaw = res3 && res3.statusCode === 200 ? res3.body : null;
      const feedbackSubmissionScores = feedbackSubmissionScoresRaw ? feedbackSubmissionScoresRaw.results : [];
      const userFeedbackSubmissionScores = feedbackSubmissionScores.find(i => i.user === userId);
      const evalSubmission = userFeedbackSubmissionScores ? userFeedbackSubmissionScores.adjusted_score : 0;

      engagementRaw = res4 && res4.statusCode === 200 ? res4.body : null;
      const engagementUserScores = engagementRaw ? engagementRaw.results : [];
      const engagement = engagementUserScores.length ? Number(engagementUserScores[0].overall_user_engagement) : 0;

      this.setState({
        selected: {
          fullname: `${student.user.first_name} ${student.user.last_name}`,
          teamName,
          teamScore,
          collaborationScore,
          evalSubmission,
          engagement,
          student
        },
        isFetching: false,
      });
    }
  }

  formatNumber = value => value ? `${Number((value * 100).toFixed(2))}%` : '---';

  setDropdownValue = callback => {
    this.setState({
      setDropdownValueCallback: callback,
    }, () => {
      const students = this.studentsList;

      if (callback && students && students.length > 0) {
        callback(students[0]);
      }
    });
  }

  onEvaluationShowToggle = () => {
    const { evaluationVisible } = this.state;
    this.setState({ evaluationVisible: !evaluationVisible });
  }

  render() {
    const {
      show,
      onHide,
      loading,
      roundNumber,
      survey,
      reports
    } = this.props;
    const {
      students,
      selected,
      isFetching,
      evaluationVisible
    } = this.state;

    const surveyName = survey ? survey.name : '';

    return (
      <EngagementModal
        show={show}
        onHide={onHide}
        backdropClassName="transparent-backdrop"
      >
        <ModalBody evaluationVisible={evaluationVisible}>
          {loading === true && <Loader type="ball-scale-ripple" active />}
          {loading === false && (
            <FullWidth>
              <TitleRow>
                {selected && (
                  <Title>{selected.fullname}</Title>
                )}
                {students && (
                  <Dropdown
                    placeholder="Select Student"
                    options={this.studentsList}
                    onChange={this.onSelectStudent}
                    DropDownContainer={DropDownContainer}
                    DropDownHeader={DropDownHeader}
                    DropDownListContainer={DropDownListContainer}
                    DropDownHeaderArrow={DropDownHeaderArrow}
                    ArrowIcon={ArrowIcon}
                    setValueCallback={this.setDropdownValue}
                  />
                )}
              </TitleRow>
              <SubTitleRow>
                {!isFetching && selected && selected.teamName && (
                  <SubTitle>{selected.teamName}</SubTitle>
                )}
                {!isFetching && selected && roundNumber && surveyName && (
                  <SubTitle>Round {roundNumber} / {surveyName}</SubTitle>
                )}
              </SubTitleRow>
              {(isFetching || !selected) && <Loader type="ball-scale-ripple" active />}

              {!isFetching && selected && (
                <BlockWrapper>
                  <GreyBlock fullWidth>
                    <GreyBlockTitle>Scores</GreyBlockTitle>
                    <GreyBlockRow>
                      <GreyBlockCell>
                        <GreyBlockLabel>Team</GreyBlockLabel>
                        <GreyBlockValue>{getPercentage(selected.teamScore)}</GreyBlockValue>
                      </GreyBlockCell>

                      <GreyBlockCell>
                        <GreyBlockLabel>Collaboration</GreyBlockLabel>
                        <GreyBlockValue>{getPercentage(selected.collaborationScore)}</GreyBlockValue>
                      </GreyBlockCell>

                      <GreyBlockCell>
                        <GreyBlockLabel>Eval Submission</GreyBlockLabel>
                        <GreyBlockValue>{getPercentage(selected.evalSubmission)}</GreyBlockValue>
                      </GreyBlockCell>

                      <GreyBlockCell>
                        <GreyBlockLabel>Engagement</GreyBlockLabel>
                        <GreyBlockValue>{getPercentage(selected.engagement)}</GreyBlockValue>
                      </GreyBlockCell>
                    </GreyBlockRow>
                  </GreyBlock>
                  {
                    survey &&
                    <GreyBlock fullWidth>
                      <GreyBlockRow justify="flex-start">
                        <GreyBlockTitle>Teamwork Summary &nbsp;&nbsp;&nbsp;</GreyBlockTitle>
                        <StudentStatsViewEvaluation
                          survey={survey}
                          reports={reports}
                          onEvaluationShowToggle={this.onEvaluationShowToggle}
                          students={students}
                          selected={selected}
                        />
                      </GreyBlockRow>
                      <GreyBlockText>No information available at this time.</GreyBlockText>
                    </GreyBlock>
                  }
                </BlockWrapper>
              )}
            </FullWidth>
          )}
        </ModalBody>
      </EngagementModal >
    );
  }
}

export default StudentStatsPopup;



// WEBPACK FOOTER //
// ./src/instructor/components/student-stats-popup.js